import {createDropdownFilter, onChangeFilters} from "../../application/utils/filters";

export const BlockJobsLoop = ( block: HTMLElement ) => {
	const JobsLoopObject = {
		container: block,
		items: block.querySelectorAll( '.loop-item--job-excerpt' ) as NodeListOf<HTMLElement>,
		moreButton: block.querySelector( '.button--more' ) as HTMLElement,
		_init(): void {
			this._bindClass();
			this._bindEvents();
			this._initFilters();
		},
		_bindClass(): void {
			this.filterJobs     = this.filterJobs.bind(this);
			this.hideMoreButton = this.hideMoreButton.bind(this);
			this.showMore       = this.showMore.bind( this );
		},
		_bindEvents(): void {
			onChangeFilters( this.filterJobs );
			this.moreButton?.addEventListener( 'click', this.showMore );
		},
		_initFilters(): void {
			document.querySelectorAll( '.dropdown-filter' ).forEach( filter => {
				createDropdownFilter(filter as HTMLElement);
			});
		},
		filterJobs( event: CustomEvent ): void {
			const filters = event.detail as Record<string, string[]>;

			const filterMap: Record<string, keyof DOMStringMap> = {
				'employment-type': 'jobEmploymentType',
				'location': 'jobLocation',
				'department': 'jobDepartment',
			};

			console.log(filters);

			this.items.forEach((item: HTMLElement) => {
				let visible = true;

				Object.entries(filters).forEach(([filterName, values]) => {
					if (!visible || !values.length) {
						return;
					}

					const datasetKey = filterMap[filterName];

					if (!datasetKey) {
						return;
					}

					const itemValue = item.dataset[datasetKey];

					if (!values.includes(itemValue ?? '')) {
						visible = false;
					}
				});

				item.style.display = visible ? 'block' : 'none';
			});

			this.hideMoreButton();
		},
		hideMoreButton(): void {
			this.moreButton.style.display = 'none';
		},
		showMore( event: Event ): void {
			event.preventDefault();

			this.items.forEach( ( item: HTMLElement ) => {
				item.style.display = 'block';
			} );

			this.hideMoreButton();
		},
	}

	JobsLoopObject._init();
	return JobsLoopObject;
};
